import api from "../http/api";

export const getNotifications = async (institutionId, { unreadOnly = false, onlyMine = false, archived = false, limit = 20 } = {}) => {
  try {
    const response = await api.client.get("api/v1/Notifications", {
      headers: { institutionId },
      params: { unreadOnly, onlyMine, archived, limit }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar notificações:", error);
    return { notifications: [], unreadCount: 0 };
  }
};

export const getUnreadCount = async (institutionId, { onlyMine = false } = {}) => {
  try {
    const response = await api.client.get("api/v1/Notifications/unread-count", {
      headers: { institutionId },
      params: { onlyMine }
    });
    return response.data.unreadCount;
  } catch (error) {
    console.error("Erro ao buscar contagem de notificações:", error);
    return 0;
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    await api.client.put(`api/v1/Notifications/${notificationId}/read`);
  } catch (error) {
    console.error("Erro ao marcar notificação como lida:", error);
  }
};

export const markAllNotificationsAsRead = async (institutionId) => {
  try {
    await api.client.put("api/v1/Notifications/read-all", {}, {
      headers: { institutionId }
    });
  } catch (error) {
    console.error("Erro ao marcar todas notificações como lidas:", error);
  }
};

export const archiveAllNotifications = async (institutionId) => {
  try {
    await api.client.put("api/v1/Notifications/archive-all", {}, {
      headers: { institutionId }
    });
  } catch (error) {
    console.error("Erro ao limpar notificações:", error);
  }
};

